import React, {Fragment, useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { borrarInfoDBAction, proximaRondaAction, proximoEjercicioAction, resetearEjercicioAction, setearItemGrupoAction, setearSesionTerminadaAction } from '../../../actions/estadoEjercicioActions';
import HeaderEjercicios from '../../AuxiliaresPaginas/HeaderEjercicios';
// css
import {Consignas, Flex, Btn, Hr} from '../../Css/MetodosCSS/StyledMethods';
import { ContainerFlex } from '../../Css/MetodosCSS/StyledLN2Todos';
import { Img } from '../../Css/StyledForm';
import { BtnTiempo } from '../../Css/MetodosCSS/StyledEjercicios';
import { aumentarRondaAction, zeroContadorConCorreccionAction } from '../../../actions/botoneraEjercicioActions';

const FinalEjercicio = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const informacion = [
        {id:'3', seccion: "1", nombre_seccion: "CONCIENCIA FONOLÓGICA", unidad: "2", nombre_unidad: "conciencia silábica - segmentar - ensamblar - identificar", nombre_ejercicio: "SCR3", estado: 0},
        {id:'4', seccion: "1", nombre_seccion: "CONCIENCIA FONOLÓGICA", unidad: "2", nombre_unidad: "conciencia silábica - segmentar - ensamblar - identificar", nombre_ejercicio: "SCR4", estado: 0},
        {id:'6', seccion: "1", nombre_seccion: "CONCIENCIA FONOLÓGICA", unidad: "3", nombre_unidad: "conciencia fonémica - inicial y final - manipulación", nombre_ejercicio: "SCR6", estado: 0},
        {id:'7', seccion: "1", nombre_seccion: "CONCIENCIA FONOLÓGICA", unidad: "3", nombre_unidad: "conciencia fonémica - inicial y final - manipulación", nombre_ejercicio: "SCR7", estado: 0},
        {id:'8', seccion: "2", nombre_seccion: "LECTURA", unidad: "4", nombre_unidad: "identificación de letras", nombre_ejercicio: "SCR8", estado: 0},
        {id:'10', seccion: "2", nombre_seccion: "LECTURA", unidad: "6", nombre_unidad: "principio alfabético", nombre_ejercicio: "SCR11", estado: 0},
        {id:'11', seccion: "2", nombre_seccion: "LECTURA", unidad: "7", nombre_unidad: "sílabas", nombre_ejercicio: "SCR12", estado: 0},
        {id:'12', seccion: "2", nombre_seccion: "LECTURA", unidad: "8", nombre_unidad: "palabras", nombre_ejercicio: "SCR13", estado: 0},
        {id:'14', seccion: "2", nombre_seccion: "LECTURA", unidad: "10", nombre_unidad: "pseudopalabras", nombre_ejercicio: "SCR14", estado: 0},
        {id:'15', seccion: "3", nombre_seccion: "DENOMINACIÓN RÁPIDA", unidad: "11", nombre_unidad: "Denominación rápida", nombre_ejercicio: "SCR16", estado: 0},
        {id:'16', seccion: "3", nombre_seccion: "DENOMINACIÓN RÁPIDA", unidad: "11", nombre_unidad: "Denominación rápida", nombre_ejercicio: "SCR17", estado: 0}
    ];

    const [cambio, setCambio] = useState(false);
    const [disable, setDisable] = useState(true);
    const [nombreEjercicio, setNombreEjercicio] = useState();
    const [informacionObjetivos, setInformacionObjetivos] = useState(informacion);

    const rol = useSelector(state => state.usuario.rol);
    const sesion = useSelector((state) => state.ejercicio.sesion);
    const sesionTer = useSelector((state) => state.ejercicio.sesionTerminada);
    const url = useSelector((state) => state.ejercicio.url);
    const urlAnterior = useSelector((state) => state.ejercicio.urlAnterior);
    const ejercicio = useSelector((state) => state.ejercicio.ejercicio);
    const ronda = useSelector((state) => state.ejercicio.ronda);
    const primerTiempo = useSelector((state) => state.ejercicio.primer_tiempo);
    const segundoTiempo = useSelector((state) => state.ejercicio.segundo_tiempo);
    const ejercicio_almacenado = useSelector((state) => state.ejercicio.ejercicio_almacenado);
    const grupo = useSelector((state) => state.ejercicio.grupo);
    const item_grupo = useSelector((state) => state.ejercicio.item_grupo);

    //screening inicia
    const listaPacientes = useSelector(state => state.informacion.lista_pacientes);
    const idPacienteScreening =  useSelector(state => state.usuario.nombrePaciente);
    //screening fin 

    const siguienteEjercicio = (e) => {
        e.preventDefault();
        let informacionDos;
        const estadoEjercicio = sesion.find(item => item.estado_ejercicio === 'pendiente');
        if(estadoEjercicio){
            dispatch(borrarInfoDBAction());
            setCambio(true);
            return;
        } else {
            const verifico = sesionTer.find(item => item.status === 'pendiente');
            if(verifico) {
                dispatch(borrarInfoDBAction());
                setCambio(true);
                return;
            } else {
                informacionDos = {
                    sesionTerminada: []
                }
                navigate('/escritorio-paciente');
                dispatch(resetearEjercicioAction());
                dispatch(setearSesionTerminadaAction(informacionDos));
            }
        }
        
    }

    // screening inicia

    useEffect(() => {
        const primerEjercicio = informacionObjetivos.find(item => item.estado == 0)?.nombre_ejercicio;

        setNombreEjercicio(primerEjercicio);

    }, [informacionObjetivos])

    useEffect(() => {
        if(rol === '800000') {
            const infoPaciente = listaPacientes.filter(item => item.id_paciente_screening === idPacienteScreening)[0]
            const newList = JSON.parse(JSON.stringify(informacion));
            newList[0].estado = infoPaciente.SCR3;
            newList[1].estado = infoPaciente.SCR4;
            newList[2].estado = infoPaciente.SCR6;
            newList[3].estado = infoPaciente.SCR7;
            newList[4].estado = infoPaciente.SCR8;
            newList[5].estado = infoPaciente.SCR11;
            newList[6].estado = infoPaciente.SCR12;
            newList[7].estado = infoPaciente.SCR13;
            newList[8].estado = infoPaciente.SCR14;
            newList[9].estado = infoPaciente.SCR16;
            newList[10].estado = infoPaciente.SCR17;

            setInformacionObjetivos(newList);
        }
        
    }, [listaPacientes])

    const siguienteEjercicioScreening = (e) => {
        e.preventDefault();
        dispatch(proximoEjercicioAction());
        navigate(`/escritorio/metodos/screening/${nombreEjercicio}`);
    }

    const resetFinalizarScreening = (e) => {
        e.preventDefault();
        dispatch( resetearEjercicioAction() );
        navigate(`/escritorio/screening`);
    }

    // screening fin

    const resetearRonda = (e) => {
        e.preventDefault();
        dispatch(zeroContadorConCorreccionAction());
        dispatch(aumentarRondaAction())
        dispatch(proximaRondaAction());
        navigate(`../escritorio/metodos/${urlAnterior}${ejercicio}`, {replace: true});
    }

    const irProximoEjercicio = (e) => {
        e.preventDefault();
        const index = item_grupo+1;
        dispatch(proximoEjercicioAction());
        navigate(grupo[index].url);
        dispatch(setearItemGrupoAction(index));
    }

    const volverHacer = (e) => {
        e.preventDefault();
        dispatch(proximoEjercicioAction());
        navigate(url);
    }

    const resetFinalizar = () => {
        dispatch( resetearEjercicioAction() );
        navigate(`/escritorio/metodos/${urlAnterior}`);
    }

    useEffect(() => {
        if(!cambio){
            return
        }
        dispatch(proximoEjercicioAction());
        navigate(url);
    }, [cambio])

    useEffect(() => {
        setDisable(false);
    }, [sesion])
    
    useEffect(() => {
        if(!ejercicio_almacenado || rol !== '894616' || sesionTer.length === 0) {
            return;
        }
        const sesionTerminada = JSON.parse(JSON.stringify(sesionTer));
        const index = sesionTerminada.findIndex(item => item.url === url);
        sesionTerminada[index].nuevaRepeticion = sesionTerminada[index].nuevaRepeticion + 1;
        if(sesionTerminada[index].cantidad === sesionTerminada[index].nuevaRepeticion){
            sesionTerminada[index].status = 'completado';
        }
        const informacion = {
            sesionTerminada
        }
        dispatch(setearSesionTerminadaAction(informacion));
    }, [ejercicio_almacenado])

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} minMay={false} />
            {ejercicio === 'LN7' || ejercicio === 'LN7IS' ? 
                <ContainerFlex display="flex" direction="column">
                    <ContainerFlex display="flex" direction="column" align="center" justify="center">
                        <Img width="220px" src={`/img/cronometro.png`} />

                        <ContainerFlex display="flex" justify="space-evenly">
                            <BtnTiempo margin="1rem 2rem" width="4rem" height="2rem" bg="rgba(250, 250, 250, 1)" shadow="0px 4px 4px rgba(0, 0, 0, 0.25)" border="none" radius="10px" font="1rem">
                                {primerTiempo === '' ? null : primerTiempo}
                            </BtnTiempo>
                            <BtnTiempo margin="1rem 2rem" width="4rem" height="2rem" bg="rgba(250, 250, 250, 1)" shadow="0px 4px 4px rgba(0, 0, 0, 0.25)" border="none" radius="10px" font="1rem">
                                {segundoTiempo === '' ? null : segundoTiempo}
                            </BtnTiempo>
                        </ContainerFlex>
                    </ContainerFlex>

                    <ContainerFlex display="flex" direction="column"  align="center">
                        {ronda === 1 ?
                            <BtnTiempo
                                onClick={(e) => resetearRonda(e)}
                            >
                                Repetir
                            </BtnTiempo>
                            : null
                        }
                    </ContainerFlex>
                </ContainerFlex>
            :
                null
            }
            {rol ==='894616' ?
            <Flex>
                <Flex direction="column">
                    <Consignas>Finalizar  entrenamiento</Consignas>
                    <Hr/>
                    <Btn margin="30px"><img src={`/img/icono_finalizar_tratamiento.png`} alt=''/></Btn>
                </Flex>
                <Flex direction="column">
                    <button
                        disabled = {disable}
                        onClick={(e) => siguienteEjercicio(e)}
                    >
                        Continuar próximo ejercicio
                    </button>
                </Flex>
            </Flex>
            :
            rol ==='800000' ?
                <Flex>
                    {nombreEjercicio == undefined ?
                    <Flex direction="column">
                        <Consignas>Volver al Menú</Consignas>
                        <Hr/>
                        <Btn margin="30px"
                            onClick={(e) => resetFinalizarScreening(e)}
                        >
                            <img src={`/img/LogoAtras.png`} alt=''/>
                        </Btn>
                    </Flex>
                    :
                    <>
                        <Flex direction="column">
                            <Consignas>Volver al Menú</Consignas>
                            <Hr/>
                            <Btn margin="30px"
                                onClick={(e) => resetFinalizarScreening(e)}
                            >
                                <img src={`/img/LogoAtras.png`} alt=''/>
                            </Btn>
                        </Flex>
                        
                        <Flex direction="column">
                            <button
                                disabled = {disable}
                                onClick={(e) => siguienteEjercicioScreening(e)}
                            >
                                Continuar próximo ejercicio
                            </button>
                        </Flex>
                    </>
                    }
                    
                </Flex>
            :
            <Flex>
                 {/* <Flex direction="column">
                    <Consignas>Agendar para el domicilio</Consignas>
                    <Hr/>
                    <Btn margin="30px"><img src={`/img/icono_agendar_al_domicilio_color.png`} alt=''/></Btn>
                </Flex> */}
                <Flex direction="column">
                    <Consignas>Volver al Menú</Consignas>
                    <Hr/>
                    <Btn margin="30px"
                        onClick={resetFinalizar}
                    >
                        <img src={`/img/LogoAtras.png`} alt=''/>
                    </Btn>
                </Flex>
                <Flex direction="column">
                    <Consignas>Rehacer</Consignas>
                    <Hr/>
                    <Btn margin="30px"
                        onClick={(e) => volverHacer(e)}
                    >
                        <img src={`/img/icono_rehacer.png`} alt=''/>
                    </Btn>
                </Flex>
                {grupo.length === 0 || grupo.length === item_grupo +1 ? null : 
                <Flex direction="column">
                    <Consignas>Continuar próximo ejercicio</Consignas>
                    <Hr/>
                    <Btn margin="30px" style={{width: "50px", height: "34px"}}><img style={{height: "auto", width: "100%"}} src={`/img/siguiente_ejercicio.png`} alt=''
                        onClick={(e) => irProximoEjercicio(e)}
                    /></Btn>
                </Flex>
                }
            </Flex>
            }        
        </Fragment>
    );
}
 
export default FinalEjercicio;